module.exports = __webpack_public_path__ + "static/media/98AE9265-6F77-42AD-8CA4-F284F25634C8.7e9ebaa7.jpg";